import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { productApi } from '@getgreenline/products'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { csvStringToFile, parseErrorMsg } from '../../../../utilities/helpers'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import { message } from 'antd'
import moment from 'moment'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  isLoading: boolean
}

@inject('currentCompanyStore')
@observer
export class ExportProductsPricesButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  export = async () => {
    try {
      this.setState({ isLoading: true })

      const company = this.props.currentCompanyStore!.company!
      const productFilter =
        this.props.currentCompanyStore!.productStore!.productFilter!.productFilter

      const csvString = await productApi.getProductsPricesExport(company.id, productFilter)

      csvStringToFile(csvString, `products-prices-export-${moment().format('YYYY-MM-DD')}`)
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while exporting product list')
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    return (
      <BlazeButton
        buttonProps={{
          icon: 'download',
          disabled: this.state.isLoading,
          onClick: this.export,
          loading: this.state.isLoading,
        }}
        titleProps={{
          title: 'Export CSV',
        }}
      />
    )
  }
}
